import { Login, LoginResponse } from 'domain/login';

export const loginMapper = (
  {
    birthdate,
    branch_office_id,
    cash_opening_id,
    cash_register,
    cash_register_id,
    company_id,
    company_address,
    company_name,
    company_ruc,
    company_phone,
    company_logo,
    company_billing_enabled,
    dni,
    email,
    first_name,
    gender,
    id,
    last_name,
    role_id,
    status,
    branch_office,
  }: LoginResponse,
  token: string,
): Login => ({
  birthdate,
  branchOfficeId: branch_office_id,
  cashOpeningId: cash_opening_id,
  cashRegister: {
    id: cash_register?.id,
    invoiceVoucherId: cash_register?.invoice_voucher_id,
    name: cash_register?.name,
    receiptVoucherId: cash_register?.receipt_voucher_id,
    status: cash_register?.status,
  },
  cashRegisterId: cash_register_id,
  company: {
    id: company_id,
    address: company_address,
    name: company_name,
    ruc: company_ruc,
    phone: company_phone,
    logo: company_logo ?? null,
    billingEnabled: company_billing_enabled,
  },
  branchOffice: branch_office,
  dni,
  email,
  firstName: first_name,
  gender,
  id,
  lastName: last_name,
  roleId: role_id,
  status,
  token,
});
